import { CountryIconProps } from './types';

const GA = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3625)">
      <path
        d="M23.2536 16.175C23.736 14.875 24 13.4689 24 12.0011C24 10.5332 23.736 9.12721 23.2536 7.82718L12 6.78369L0.746391 7.82718C0.264047 9.12721 0 10.5332 0 12.0011C0 13.4689 0.264047 14.875 0.746391 16.175L12 17.2184L23.2536 16.175Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0007 23.9997C17.1603 23.9997 21.5588 20.7432 23.2543 16.1736H0.74707C2.44263 20.7432 6.8411 23.9997 12.0007 23.9997Z"
        fill="#0052B4"
      />
      <path
        d="M12.0007 0.000732422C6.8411 0.000732422 2.44263 3.25723 0.74707 7.82684H23.2543C21.5588 3.25723 17.1603 0.000732422 12.0007 0.000732422Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3625">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GA;
